export default {
  mainPage: {
    p1: {
      h: 'Leading technology advancements',
      p1: 'in low carbon, renewable energy,',
      p2: 'efficiency and sustainability.',
      p3: '',
    },
    p2: {
      p1: 'DIMER is leading the world in gas processing, power-to-gas, CCUS,',
      p2: 'clean enegy development, and energy efficiency.',
      p3: '',
      p4: '',
    },
    p3: {
      p1: 'Discover', // 此处的DIMER文字固定显示，不需要体现在文本内容中
    },
  },
  mainMenu: {
    homePage: 'Home',
    about: 'About DIMER',
    t$e: 'Technology & Engineering',
    p$s: 'Projects & Services',
    contact: 'Contact Us',
  },
  about: {
    aboutDIMER: 'About us',
    DIMER_BOARD: 'DIMER\'s Board',
    m$c: 'Management & Advisory',
    a$r: 'Awards & Recognition',
    latestNews: 'Latest News',
    latestProj: 'Latest Project',
  },
  t$e: {
    gasProcessTech: 'Gas processing technologies',
    ptgTech: 'Power-to-gas technologies',
    cleanEnergyDev: 'Clean energy development',
  },
  p$s: {
    h2ch4Rec$co2Capt: 'H2/CH4 recovery & CO2 capture',
    renewablePower: 'Renewable power-to-H2',
    co2Sep$Capt: 'CO2 separation & utilities',
    co2Capt$reuse: 'Smart microgrid with H2 & BESS',
    wasteWaterTreat: 'Industrial waste-gas management',
  },
  toolBar: {
    searchPlaceholder: 'Search...',
  },
  discoveryPage: {
    title: 'DIMER\'S CAPABILITY',
    p1: {
      p1: 'R&D, design, engineering, construction and',
      p2: 'management of gas and clean energy projects.',
    },
    p2: {
      p1: 'DIMER dedicates to design and engineering of technologies and solutions for',
      p2: 'gas processing, low-carbon energy gas,',
      p3: 'carbon capture & CCUS, clean energy and advanced porous materials.',
    },
  },
  discoveryPage2: {
    title: 'DIMER\'S MISSION',
    p1: {
      p1: 'DIMER cares about',
      p2: 'our air and sky ...',
    },
    p2: {
      p1: 'DIMER is to develop low carbon fuels and renewable energy',
      p2: 'for environmental sustainability.',
      p3: 'DIMER is to create novel technologies and engineering solutions for',
      p4: 'gas processing and clean energy.',
      p5: 'DIMER is to improve the energy efficiency and reduce',
      p6: 'the impact of fossil fuels.',
      p7: '',
    },
  },
  discoveryPage3: {
    title: 'DIMER\'S VISION',
    p1: {
      p1: '',
      p2: '',
    },
    p2: {
      p1: 'DIMER pursues the tenet of \'low carbon, renewable energy, efficiency and sustainbility\'.',
      p2: 'DIMER is committed to developing more efficient clean energy for our society.',
      p3: 'DIMER focuses on technologies that help fighting the climate changes.',
    },
  },
  contact: {
    title: 'CONTACT',
    company: 'Dimer Technologies Pty Ltd',
    address: 'Level 27, 101 Collins Street',
    city: 'Melbourne 3000,  Australia',
    phone: 'T: +61 3 9653 6499',
    email: 'E: info_at_dimer.com.au',
  },
  copyright: {
    copyright: 'Copyright © Dimer Technologies Pty Ltd 2020. ACN 155 533 225',
    law: 'Legal declaration: ',
    lawLink: 'Intellectual property',
  },

  aboutPage: {
    p1: {
      title: 'About DIMER',
      p1: `DIMER cares about
     our air and sky ... `,
      p2: 'low carbon, renewable energy,',
      p2_1: 'efficiency and sustainbility.',
      p3: '',
      p4: '',
    },
    p2: {
      p1: 'Dimer Technologies was founded by leading experts originally from Australia\'s CSIRO and National Research Centre of Greenhouse Gases (CO2-CRC), and have continuing cooperation with Australian CO2-CRC, Commonwealth Scientific and Industrial Research Organization (CSIRO), Air Products & Chemical of USA, Norton Engineering of USA, The University of Melbourne and Monash University.',
      p2: 'State-of-the-Art R&D Facilities and world-leading Labs',
      p3: 'DIMER has advanced R&D facilities and world-leading labs backed up by SINOPEC-Tianjin, UniMelb, CSIRO, CO2-CRC and Monash for design and development of superior gas technologies. DIMER\'s R&D strengths include advanced materials, process design and engineering, technology industrialization, and tailor-made technology & engineering solutions.',
      p4: 'DIMER has developed the state-of-the-art gas technologies on separation and capture of greenhouse gases (such as CO2, CH4, VOCs), hydrogen recovery and purification, renewable power-to-H2, natural gas purification and recovery, CCUS, oxygen enriched combustion and CH4 liquification.',
      p5: 'DIMER\'s gas technologies were granted the patents from Australia, USA, and Europe etc. (USA patent No. 20110005389; Intl No.PCT/AU08/01831 (covering USA, China, India and Europe); Australian patent No. 2008336265 + No.2013201122/No.2016201267; Chinese patents No.201611219796.5 + No.201621438243.4. DIMER has the full ownership or exclusive execution rights of these patents.',
      p6: '',
      p7: '',
      p8: '',
      news: {
        state: 'Ongoing Projects',
        news1: 'Recovery of H2 from refinery tail-gas',
        news2: 'Renewable power-to-H2',
        news3: 'CO2 capture and liquification',
        news4: 'CH4 purification and liquification',
      },
    },
    p3: {
      title: 'Board and Management',
      p1: `DIMER co-founders, directors and key staff were professors and senior scientists from
     Australian CO2-CRC, CSIRO and The University of Melbourne. They have distinguished
     working experience and education from Australian CSIRO, UniMelb, Monash, USA's
     MIT, Air Products & Chemicals, and China's Peking, Tsinghua and Tianjin Universities.
     They also have established collaboration with leading international companies.`,
      userInfo: {
        DrLMS: {
          name: 'Dr Ming S. Liu',
          description: 'Founder / Managing Director / CEO',
          content: 'Dr Ming S. Liu is a leading expert in materials design and development, low-carbon energy gas, CCUS and gas processing technologies. He is also an expert in clean-energy development and management. Prior to joining DIMER, Dr Liu was a Senior Scientist and Project Leader at CSIRO (He holds a prestigious Honorary Fellowship from CSIRO). Dr Liu was awarded his PhD in Materials Physics from The University of Melbourne.',
        },
        MrTJing: {
          name: 'Mr Thomas Jing',
          description: 'Executive Director',
          content: 'Mr Jing is the Group Chairman of Aurorean Energy Ltd (AEL, China). AEL is a noted energy company committed to the development of IGCC power generation, renewable energy, low-carbon energy gas and energy management. AEL and DIMER are the JV business partners in China.',
        },
        DrZJ: {
          name: 'Dr Tony Zhang',
          description: 'Co-Founder',
          content: 'Dr Tony Zhang is an expert in gas separation technologies, adsorption materials and process engineering. Prior to joining DIMER, he was a Research Fellow and Project Manager at Australian CO2-CRC. Dr Zhang obtained his PhD in Chemical Engineering from Monash University.',
        },
        DrPenny: {
          name: 'Dr Penny Xiao',
          description: 'Chief Technology Officer (CTO)',
          content: 'Dr Xiao is a leading expert in gas technologies, adsorption materials, processing and chemical engineering. Prior to joining DIMER, she is a Senior Research Fellow at The University of Melbourne and Australian CO2-CRC. Dr Xiao obtained her PhD in Chemical Engineering from The University of Melbourne.',
        },
        AliciaLi: {
          name: 'Ms Alicia Li (FA, MIntlB)',
          description: 'Financial Adviser',
          content: 'Ms Alicia Li is a highly accredited Financial Adviser. She has 20+ years of experience in corporate and private finance. She was awarded an Australian CFA and MIntlB from the University of Melbourne.',
        },
        MrYCQ: {
          name: 'Mr Yu Changqing',
          description: 'Operation Manager in China',
          content: 'Mr Yu a well-recognized engineer and expert in gas processing, gas liquification and refinery process. He has accumulated experience of over 25 years and now managing DIMER\'s H2-plant with SINOPEC-Tianjin\'',
        },
        DrTao: {
          name: 'Dr Daniel Tao',
          description: 'Technology Manager',
          content: 'Daniel is a principal scientist in chemical engineering, gas processing technology and advanced materials. Prior to joining DIMER, he worked with BASF-China for years. Dr Tao was awarded his PhD in Chemical Engineering from The University of Melbourne.',
        },
        PfPaul: {
          name: 'Prof Paul Webley',
          description: 'Executive Director',
          content: 'Prof Webley is Professor & Director of Woodside-Monash Energy Partnership and Hydrogen Program at Monash University. He is also Chief Scientist of Australian CRC for Greenhouse Gas Technologies. Prof Webley is a world-leader in gas separation technology, low-carbon energy gas, and clean energy optimization. He has also served as Director at Chemical Engineering of The Univ. of Melbourne and as a senior manager at Air Products of USA. Professor Webley received a Ph.D. from MIT.',
        },
      },
    },
    p4: {
      title: 'Advisory Committee',
      userInfo: {
        DrKL: {
          name: 'Dr Kevin Li',
          company: 'UniMelb',
        },
        ProfPW: {
          name: 'Professor Paul Webley',
          company: 'UniMelb',
        },
        DrRT: {
          name: 'Dr Richard Todd',
          company: 'Norton',
        },
        MrMjL: {
          name: 'Mr Mengjiang Liu',
          company: 'Skywell',
        },
        DrDX: {
          name: 'Dr Ding Xue',
          company: 'Sinopec',
        },
        MrJsL: {
          name: 'Mr Junshan Liu',
          company: 'CNOOC',
        },
      },
    },
    p5: {
      title1: 'Awards',
      title2: 'and Recognition',
      content: 'DIMER works closely with the industries of energy, oil & gas, petrochemical, resources, food & agriculture, environment, and biotech etc. DIMER also exports superior Australian technologies and services to the Greater China and Pacific regions.',
    },
  },

  techPage: {
    p1: {
      title: 'Technology & Engineering',
      p1: 'DIMER excels in',
      p2: 'developing technology,',
      p3: 'engineering and',
      p4: 'service solutions.',
      p5: 'Of gas processing, low carbon',
      p6: 'energy gas, CCUS and clean energy.',
    },
    p2: {
      title: 'Core Technology & Engineering',
      p1: 'DIMER\'s core technology and engineering advances are pressure-swing adsorption (PSA), vacuum-swing adsorption (VSA), power-to-hydrogen (P2H2), power-to-gas (P2G) and liquification of industrial and greenhouse gases. Superior to traditional technology, DIMER develops more streamlined and efficient multi-column VSA/PSA for separation and capture of a large variety of gases (such as hydrogen H2, methane CH4 and carbon dioxide CO2), or further condense them to the application liquids.',
      p2: 'DIMER\'s technologies have been implemented in Australia and overseas for effective low-cost gas separation, capture, purification and recovery.',
      p3: '',
      p4: '',
    },
    p3: {
      title: 'Gas Processing Technologies',
      p1: 'DIMER has developed superior gas processes and advanced materials for',
      p2: '- Low carbon energy gas (such as H2, CH4 and hydrocarbons)',
      p3: '- Treatment of industrial off-gas',
      p4: '- Gas condensation or liquefaction',
      p5: '- Carbon capture and CCUS',
      p6: '',
    },
    p4: {
      title: 'Power-to-Gas Technologies',
      p1: 'Targetting energy storage and hydrogen energy application, DIMER builds up novel technologies and engineering capability of',
      p2: '',
      p3: '- Renewable power to hydrogen (Power-to-H2)',
      p4: '- CCUS to MeOH or methanation',
      p5: '- Hydrogen energy applications',
      p6: '',
      p7: '',
    },
    p5: {
      title: 'Clean Energy Development',
      p1: 'DIMER is teaming up with TeraSolar and partners to build renewable electricity/steam/hot-water for community, industrial and agricultural applications.',
      p2: '- Solar thermal energy',
      p3: '- Microgrid & micro-energy system',
      p4: '',
    },
    relevant: {
      title: 'Relevant Projects',
      project1: 'H2/CH4 recovery and CO2 capture from refinery tail-gas',
      project2: 'Renewable power-to-H2 & power-to-gas',
      project3: 'CO2 capture and utilization',
      project4: 'Smart microgrids based on H2 energy and/or BESS',
      project5: 'Industrial waste-gas management',
      knowMore: 'View More',
    },
  },

  projectPage: {
    p1: {
      title: 'Projects & Service',
      p1: 'DIMER possesses',
      p2: 'world-leading capability,',
      p3: 'in design, development',
      p4: 'and engineering.',
      p5: 'Of gas processing, low carbon',
      p6: 'energy gas, CCUS and clean energy.',
    },
    p2: {
      p1: 'DIMER specializes in the design, development and engineering of processing and power-to-gas technologies for industrial gas production and off-gas treatment.',
      p2: 'Compared to conventional technology, DIMER solutions provide higher efficiency, lower pressure and lower running-cost when producing, capturing, separating and condensing various industrial gases (such as H2, CH4, CO2 and VOCs). ',
      p3: 'DIMER\'s innovative solutions have been applied in both Australia and around the world.',
    },
    p3: {
      title: 'H2/CH4 recovery and CO2 capture from refinery tail-gas',
      time: 'SINOPEC, Stage 1: 2015 - 2017; Stage 2: 2018 – present. ',
      p1: 'Refinery process uses general PSA to produce hydrogen via steam methane reforming. The hydrogen and methane is usually used for down-stream processes. However, this PSA-H2 system produces a large amount of combustible tail-gas (e.g., 31% H2 and 49% CO2). DIMER has developed an advanced VSA/PSA system for SINOPEC-Tianjin to recover hydrogen and methane and capture CO2 from the tail-gas. This technology is helping SINOPEC reduce their greenhouse gas emission, as well as create hydrogen-based clean energy.',
    },
    otherProjects: {
      title: 'Other Projects',
      t$eImg1: {
        title: 'Renewable Power-to-H2',
        time: '2018-Present',
        p1: 'Australian renewables face the challenges of redundant powers, due to the non-dispatchable solar or wind power generation. Hydrogen, as a zero-emission fuel gas and high value industrial gas, emerges as a new clean energy source and, potentially, an energy storage carrier for solar and wind powers. Teaming up with PERIC and local partners, DIMER is building a demo micro-grid level project on power-to-H2. The current power-to-H2 system is able to produce about x100 Nm3/hr ultrahigh purity H2 (99.999%). We will validate the tech pathways of injecting H2 into a natural gas mixture, or alternatively, supplying H2 to fuel cell vehicles or fuel cell power generation.',
      },
      t$eImg2: {
        title: 'CO2 capture from the power-station flue gas',
        time: '2007-2013',
        p1: 'International giant GDF Suez operates coal-fired power plants in Victoria. They requested the recovery of about 20-50 tons/day CO2 from flue gas to further treat high pH alkaline water. GDF Suez requires a leading technology with high reliability, full automation, low energy consumption, and low operation and staffing costs. We have worked with CO2-CRC in providing a state-of-the-art PSA/VSA solution to treat flue gas. The system/solution performs excellent functions with modularized equipments, high degree of automation, high capture efficiency, low energy consumption and low maintenance.',
      },
      t$eImg3: {
        title: 'CO2 capture,purification and re-use at the beverage plant',
        time: '2008-2010',
        p1: 'The Australian beverage industry uses large amount of food-grade CO2 and release of these CO2 results in waste of resources and emission problem. In 2008, Australian Coca-Cola adopted our solution to recover its exhaust gases from production lines. Our solution ensures effective recovery and purification of CO2, while complies with the food-grade requirements. The capture and purification process yields a CO2 purity exceeding expectation, and the process does not introduce any other chemical substance. The project was highly recommended by the Coca-Cola headquarters for wide implementation.',
      },
    },
    projectList: {
      project1: {
        name: 'H2/CH4 recovery and CO2 capture from refinery tail-gas',
        time: 'SINOPEC, Stage 1: 2015 - 2017; Stage 2: 2018 – present.',
        content: 'Refinery process uses general PSA to produce hydrogen via steam methane reforming. The hydrogen and methane is usually used for down-stream processes. However, this PSA-H2 system produces a large amount of combustible tail-gas (e.g., 31% H2 and 49% CO2). DIMER has developed an advanced VSA/PSA system for SINOPEC-Tianjin to recover hydrogen and methane and capture CO2 from the tail-gas. This technology is helping SINOPEC reduce their greenhouse gas emission, as well as create hydrogen-based clean energy.',
      },
      project2: {
        name: 'Renewable power-to-H2 & power-to-gas',
        time: '2019 - Present',
        content: 'Australian renewables face the challenge of redundant power, due to non-dispatchable solar/wind power generation. Hydrogen, a zero-emission fuel gas and a high value industrial gas, emerges as a completely clean energy source, and potentially as an energy storage carrier for solar and wind power. With the help of our partners, DIMER is developing multiple micro-grid level power-to-H2 projects. Our current power-to-H2 system is able to produce hydrogen with ultrahigh purity (99.999%). We are also working on other technical and commercial pathways of injecting H2 into a natural gas mixture, refuelling H2 into fuel cell vehicles, and fuel-cell power generation.',
      },
      project3: {
        name: 'CO2 capture and utilization',
        time: '2007 - 2013',
        content: 'International energy giant GDF Suez operates coal-fired power plants in Victoria. In 2007, they requested the recovery of 20-50 tons of CO2 from flue gas per day for treatment of high pH alkaline water. GDF Suez required a completely reliable solution that was fully automated and had minimal energy consumption with low operation and staffing costs. We worked with CO2-CRC to provide a state-of-the-art VPSA solution to treat flue gas. The solution performed excellently with modularized equipment and high capture efficiency.',
      },
      project4: {
        name: 'Smart microgrids based on H2 energy and/or BESS',
        time: '2018 - Present',
        content: 'In order to meet the power, steam and thermal energy requirements of the industry and community, DIMER, along with TeraSolar Technology, Aurorean Energy and other partners, has committed to applying hydrogen and other gases into microgrids and distributed energy stations. By integrating renewable energy sources, heat (steam), electricity and gas will be co-generated as a smart energy supply.\n' +
          '\n' +
          'DIMER has completed the feasibility designs and basic designs for an Australian power company, a natural gas company, and a food processing enterprise, etc., and is undertaking the projects’ EPC implementation.',
      },
      project5: {
        name: 'Industrial waste-gas management',
        time: '2019 - Present',
        content: 'Industrial processes will usually generate harmful waste such as water, gas and slag. Industrial off-gases account for more than 80% of total GHG emissions. Excessive production of petroleum, chemicals, power, metallurgy, food, coal, building materials and textiles could seriously pollute the environment, destroy ecology, and cause irreversible damage to the industry, environment and human life.\n' +
          '\n' +
          'DIMER is working closely with SINOPEC refineries, chemical plants and local chemical parks to work towards comprehensive treatment of industrial off-gas within the plant or chemical park. Using our gas technologies, we hope to systemically recover high-value gases, reduce GHG emissions and achieve greater environmental and economic stability.\n',
      },
    },
    globalPartner: {
      title: 'DIMER: PAST PROJECTS AND SERVICES',
      p1: 'We listen, we understand, and we work with you ...',
      p2: '',
      p3: '',
    },
  },
  contactPage: {
    p1: {
      title: 'Contact Us',
      shanghaiOffice: {
        name: 'Shanghai Office',
        area: 'Shanghai, China',
        address: '20-21F DBS Bank Tower, 1318 Lujiazui Ring Road, Pudong New Area, Shanghai, China 200120',
        mCode: '',
        phone1: 'T: +86 21 6886 9881',
        phone2: 'F: +86 21 6886 9882',
        email: 'E: info_at_dimer.com.au',
      },
      guangzhouOffice: {
        name: 'Guangzhou Office',
        area: 'Guangzhou, China',
        address: '30F One Bravo, 1 Jinsui Road, Tianhe Disgtrict, Guangzhou, China 510623',
        mCode: '',
        phone1: 'T: +86 20 8638 8698',
        phone2: 'F: +86 20 8638 8798',
        email: 'E: info_at_dimer.com.au',
      },
      MelbourneOffice: {
        name: 'Head Office',
        area: 'Level 27, 101 Collins Street,',
        address: 'Melbourne 3000',
        mCode: 'Australia',
        phone1: 'T: +61 3 96536499',
        phone2: '',
        email: 'E: info_at_dimer.com.au',
      },
    },
    p2: {
      title: 'Please feel free to contact us via this form',
      name: 'Name',
      email: 'Email',
      contact: 'Contact',
      message: 'Your message',
      sendMessage: 'Send message',
    },
    p3: {
      title: 'Partner Links',
      content: '',
    },
  },
};



// WEBPACK FOOTER //
// ./src/lang/en.js